{
	"title": "Create declaration",
	"backLinkToMaterialDetailsTitle": "Back to Material Details",
	"backLinkToMaterialDetailsWithDescriptionTitle": "Back to {{materialDescription}}",
	"backLinkToManageDeclarationsTitle": "Back to Manage declarations",
	"steps": {
		"firstStep": {
			"title": "Step 1",
			"label": "1"
		},
		"secondStep": {
			"title": "Step 2",
			"label": "2"
		},
		"thirdStep": {
			"title": "Step 3",
			"label": "3"
		}
	}
}
